import imageProperties from '../lib/image-properties'

const createQuery = () => `
  ... on LogoGridWidget {
    logoGridImages: images {
      images {
        logo_free_640 {
          ${imageProperties}
        }
      }
    }
  }
`
export default createQuery
